import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/organizations/$organizationId/admin/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/organizations/$organizationId/admin/students",
      params,
      replace: true,
    });
  },
});
